import styled from 'styled-components'

const ChooseHorseModalStyled = styled.div`
  .choose-horse-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 32px;
    position: relative;
    min-height: 300px;
    min-width: 770px;
    .close-btn {
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .race-name-container {
      margin-bottom: 16px;

      .race-name {
        font-size: 24px;
        line-height: 20px;
      }
      .gate-no {
        border-radius: 4px;
        font-size: 18px;
        padding: 2px 10px;
        &.no-1{
          background: #ffffff;
          color: #000000;
        }
        &.no-2{
          background: #000000;
          color: #ffffff;
        }
        &.no-3{
          background: red;
          color: #ffffff;
        }
        &.no-4{
          background: #3366FF;
          color: #ffffff;
        }
        &.no-5{
          background: yellow;
          color: #000000;
        }
        &.no-6{
          background: yellow;
          color: #000000;
        }
        &.no-7{
          background: green;
          color: #ffffff;
        }
        &.no-8{
          background: green;
          color: #ffffff;
        }
        &.no-9{
          background: #FF8C00;
          color: #ffffff;
        }
        &.no-10{
          background: #FF8C00;
          color: #ffffff;
        }
        &.no-11{
          background: #FF33CC;
          color: #ffffff;
        }
        &.no-12{
          background: #FF33CC;
          color: #ffffff;
        }
      }
    }

    .race-info-container {
      gap: 32px;
      padding-bottom: 25px;
      border-bottom: 2px solid ${({ theme }) => theme.color.black};

      .race-info-item {
        gap: 8px;

        .race-info-title {
          font-size: 14px;
          line-height: 14px;
        }

        .race-info-content {
          font-size: 16px;
          line-height: 19px;

          img {
            width: 15px;
            height: 15px;
            margin-top: -5px;
            margin-left: 3px;
          }
        }
      }
    }

    .search-horse-container {
      margin: 21px 0 16px 0;
      .search-title {
        font-size: 16px;
        line-height: 24px;
      }

      .search-input {
        background-color: ${({ theme }) => theme.color.neutralBackground};
        opacity: 0.85;
        width: 240px;
        font-size: 16px;
      }

      .filter-type {
        height: 36px;
      }
    }
    .no-horse {
      color: #a3a5ab;
      font-size: 18px;
      padding-top: 20px;
    }

    .horse-list-container {
      max-height: 450px;
      /* overflow-y: scroll; */
      gap: 16px;
      min-height: 180px;
    }

    .horse-list-container-clone {
      max-height: 450px;
      gap: 16px;
    }

    .infinite-scroll-component::-webkit-scrollbar-track {
      border: 1px solid #000;
      padding: 2px 0;
      background-color: #000;
    }

    .infinite-scroll-component::-webkit-scrollbar {
      width: 5px;
    }

    .infinite-scroll-component::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #2f323e;
      border: 1px solid #000;
    }
    .race-type {
      padding: 0 0 6px 20px;
    }

    .box_tokyo {
      font-weight: 600;
      background-color: #ff1f6a;
      width: 80px;
      height: 31px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 1px;
    }

    .box_seoul {
      font-weight: 600;
      background-color: #1ecfcf;
      width: 80px;
      height: 31px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 1px;
    }

    .box_galaxy_road {
      font-weight: 600;
      background-color: #e6a01f;
      width: 120px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 1px;
    }
  }
`

export default ChooseHorseModalStyled
